import { useTranslation } from 'react-i18next'
import InfoBanner from '../../components/ui/InfoBanner'
import { useProxyMode } from './useProxyMode'
import './proxy.css'

/**
 * "Başkası adına çalışıyorsunuz" uyarı şeridi (089).
 *
 * <p>Uygulama kabuğuna takılır (`AppLayout`), bu yüzden **her ekranda** ve sayfa değişse de görünür:
 * vekil modunda yapılan kazara bir işlemin bedeli yüksektir, bağlamın sürekli görünür olması bu
 * riski azaltmanın en ucuz yoludur.
 *
 * <p>**Kapatılamaz** — `InfoBanner`'a `onClose` verilmez. Kapatılabilir olsaydı kullanıcı şeridi bir
 * kez kapatıp oturumun kalanını hangi kimlikle çalıştığını görmeden geçirebilirdi.
 *
 * <p>Paylaşılan `InfoBanner` yeniden kullanılır (Reuse Mandate); ton `warn` (amber): dikkat çekmeli
 * ama bir **hata** gibi görünmemeli — vekil modu normal bir çalışma biçimidir.
 */
export default function ProxyBanner() {
  const { t } = useTranslation()
  const { active, targetDisplayName, kind } = useProxyMode()

  if (!active) return null

  // FR-015: Kısıtlı Yetkili asistan, kipin İÇİNDEYKEN sınırlı olduğunu sürekli görmeli. Menü etiketi
  // yalnız menü açıkken görünür; kipte sürekli duran tek şey bu şerittir. Görmezse düğmeleri
  // bulamayınca hatayı uygulamada sanar. Tam Yetki ve vekalette ek açıklama YOK: orada bir kısıt
  // yok, uyarı eklemek olmayan bir sınırı varmış gibi gösterirdi.
  const description =
    kind === 'ASSISTANT_LIMITED'
      ? t('proxy.banner.descriptionLimitedAssistant')
      : t('proxy.banner.description')

  return (
    <div className="proxy-banner">
      <InfoBanner
        tone="warn"
        icon="pi pi-user-edit"
        title={t('proxy.banner.title', { name: targetDisplayName ?? '' })}
        description={description}
      />
    </div>
  )
}
